/* eslint-disable no-nested-ternary */
import styled from '@emotion/styled'
import {
  flexbox,
  FlexboxProps,
  fontSize,
  FontSizeProps,
  fontWeight,
  FontWeightProps,
  space,
  SpaceProps
} from 'styled-system'

type MarginProps = {
  all?: boolean
  bottom?: boolean
  left?: boolean
  lg?: boolean
  md?: boolean
  reg?: boolean
  right?: boolean
  sm?: boolean
  top?: boolean
  xl?: boolean
  xs?: boolean
}

function getWidth(props: MarginProps) {
  switch (true) {
    case props.xl:
      return '36px'
    case props.lg:
      return '24px'
    case props.md:
      return '16px'
    case props.reg:
      return '12px'
    case props.sm:
      return '8px'
    case props.xs:
      return '4px'
  }
}

export const Margin = styled.div<MarginProps>`
  margin-top: ${props => (props.top ? getWidth(props) : '')};
  margin-right: ${props => (props.right ? getWidth(props) : '')};
  margin-bottom: ${props => (props.bottom ? getWidth(props) : '')};
  margin-left: ${props => (props.left ? getWidth(props) : '')};
  margin: ${props => (props.all ? getWidth(props) : '')};
`

type FlexProps = {
  isflex?: boolean
  isinline?: boolean
  isinlineblock?: boolean
}

type WidthProps = {
  ismax?: boolean
}

export const Space = styled.div<
  WidthProps & FlexProps & SpaceProps & FontSizeProps & FlexboxProps & FontWeightProps
>`
  display: ${props =>
    props.isinline
      ? 'inline'
      : props.isinlineblock
      ? 'inline-block'
      : props.isflex
      ? 'flex'
      : 'block'};
  width: ${props => (props.ismax ? '100%' : 'auto')};
  ${space}
  ${fontSize}
  ${fontWeight}
  ${flexbox}
`
